import ObjectivesStep from './ObjectivesStep.tsx';
import type { ObjectivesStepInput } from './ObjectivesStep.validation.ts';
import type { StepConfig } from '../../../../technical/wizard/StepConfig.ts';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';

export const config = ({
  benchmarks,
  goToNextStep,
  hideEquity,
  hideLongShort,
}: {
  benchmarks: NotVerifiedAssetWithId[];
  goToNextStep: () => void;
  hideEquity?: boolean;
  hideLongShort?: boolean;
}): StepConfig<ObjectivesStepInput> => ({
  label: 'Objectives',
  element: (
    <ObjectivesStep
      goToNextStep={goToNextStep}
      benchmarks={benchmarks}
      hideEquity={hideEquity}
      hideLongShort={hideLongShort}
    />
  ),
  fields: ['portfolioAmount', 'allowShortAndLeverage', 'objectives', 'objectiveLength'],
});
